import axios from "axios";
import { IP } from "./config";
// 查询一级分类 0 一级  1 二级
export async function selectCategory(id) {
  var resp = await axios.post(`${IP}/product/selectCategory`, {
    isParent: id,
  });
  return resp.data;
}
// 新增一级分类
export async function addCategory(categoryName, img) {
  var resp = await axios.post(`${IP}/product/addCategory`, {
    categoryName,
    img,
  });
  return resp.data;
}
// 新增二级分类
export async function addCategoryTwo(parentId, categoryName, img) {
  var resp = await axios.post(`${IP}/product/addCategoryTwo`, {
    parentId,
    categoryName,
    img,
  });
  return resp.data;
}
// 修改分类
export async function updateCategory(id, categoryName, img) {
  var resp = await axios.post(`${IP}/product/updateCategory`, {
    id,
    categoryName,
    img,
  });
  return resp.data;
}

// 删除分类
export async function deleteCategory(id) {
  var resp = await axios.post(`${IP}/product/deleteCategory`, {
    id,
  });
  return resp.data;
}

// 通过一级分类id查二级分类
export async function selectCategoryTwo(id) {
  var resp = await axios.post(`${IP}/product/selectCategoryTwo`, {
    id,
  });
  return resp.data;
}

// 通过一级分类id查商品
export async function selectgoodsbysecondid(id) {
  var resp = await axios.post(`${IP}/product/selectgoodsbysecondid`, {
    id,
  });
  return resp.data;
}

// // 通过二级分类id 查商品
export async function selectGoods(data) {
  var resp = await axios.post(`${IP}/product/selectGoods`, {
    ...data,
  });
  return resp.data;
}

// 上传商品
export async function addGoods(goods, headerImg, detailsImg) {
  var resp = await axios.post(`${IP}/product/addGoods`, {
    headerImg,
    detailsImg,
    goods,
  });
  return resp.data;
}

// 修改商品
export async function updateGoods(goods, headerImg, detailsImg) {
  var resp = await axios.post(`${IP}/product/updateGoods`, {
    headerImg,
    detailsImg,
    goods,
  });
  return resp.data;
}

// 删除商品
export async function deleteGoodbyid(id) {
  var resp = await axios.post(`${IP}/product/deleteGoodsbyid`, {
    id,
  });
  return resp.data;
}

// 根据商品id删除所有商品
export async function deleteGoodsbygoodsId(goodsId) {
  var resp = await axios.post(`${IP}/myProduct/deleteGoodsbygoodsId`, {
    goodsId,
  });
  return resp.data;
}

// 查询轮播图
export async function selectBanner() {
  var resp = await axios.post(`${IP}/banner/select`, {});
  return resp.data;
}
// 新增轮播图
export async function addBanner(url, link, sort) {
  var resp = await axios.post(`${IP}/banner/add`, {
    url,
    link,
    sort,
  });
  return resp.data;
}
// 修改轮播图
export async function updateBanner(data) {
  var resp = await axios.post(`${IP}/banner/update`, data);
  return resp.data;
}
// 删除轮播图
export async function deleteBanner(id) {
  var resp = await axios.post(`${IP}/banner/delete`, {
    id,
  });
  return resp.data;
}

/* 修改轮播图状态 */
export async function updateStatus(id, status) {
  var resp = await axios.post(`${IP}/banner/updateStatus`, {
    id,
    status,
  });
  return resp.data;
}
